<div class="mt-5 mb-5 py-4 text-center">
  <p><a [routerLink]="['/impressum']" class="link text-secondary">Impressum</a> | <a [routerLink]="['/datenschutz']"
                                                                                     class="link text-secondary">Datenschutz</a>
  </p>
</div>
